module.exports = __webpack_public_path__ + "img/Hero02-6K-Fn2.ad20d15c.gif";